<template>
  <CRow class="form-group" v-if="viewMode">
    <CCol>
      <p>{{ label }}</p>
      <div style="display: flex">
        <p class="staff_name">{{ staffName }}</p>
      </div>
    </CCol>
  </CRow>
</template>
<script>
import sessionStorageUtils from '@/lib/sessionStrage/session-strage-utils'

export default {
  props: {
    label: {
      type: String,
      require: false,
    },
    viewMode: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      staffName: null,
    }
  },

  mounted() {
    const currentStaff = sessionStorageUtils.handleGetSessionStorage(
      'currentStaff'
    )

    if (!currentStaff) {
      console.error('staffデータが取得できませんでした。')
      alert('データが取得できませんでした。前のページに戻ります。')
      window.history.back()
      return
    }

    this.staffName = `${currentStaff.last_name} ${currentStaff.first_name}`
    this.$emit('selectStaffId', currentStaff.staff_id, this.staffName)
  },
}
</script>

<style lang="scss" scoped>
.staff_name {
  font-size: 18px;
  font-weight: bold;
}
</style>
